import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { User } from '../types/api.types'

export const peopleService = {
  async getAll(): Promise<User[]> {
    const { data } = await axiosInstance.get<User[]>(API_ENDPOINTS.USERS)
    return data
  },

  async getById(id: string): Promise<User | null> {
    try {
      const { data } = await axiosInstance.get<User>(API_ENDPOINTS.USER_BY_ID(id))
      return data
    } catch {
      return null
    }
  },

  async create(user: Partial<User> & { password?: string }): Promise<User> {
    const { data } = await axiosInstance.post<User>(API_ENDPOINTS.USERS, user)
    return data
  },

  async update(id: string, user: Partial<User> & { password?: string }): Promise<User> {
    const { data } = await axiosInstance.put<User>(API_ENDPOINTS.USER_BY_ID(id), user)
    return data
  },

  async delete(id: string): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.USER_BY_ID(id))
  },
}
